<template>
  <div class='align-items-center container d-flex min-vh-100 justify-content-center '>
    <div v-if='!resetFormShow' class='card card-login'>
      <div class="row mintiLogoAreaRow">
        <div class="col-12 mintiLogoArea">
          <a href="https://www.minticity.com/">
            <img src="https://cdn.minticity.com/assets/images/logo-lg.png" class="mintiLogoImg" alt="logo">
          </a>
        </div>
      </div>
      <div class="row loginFormAreaRow">
        <div class="col-12 loginFormArea">
          <div class="row my-2" v-if="!showQR">
            <div class="col-12 d-flex justify-content-center">
              <button class="btn btn-secondary m-2 pt-1 br1 text-white" id="deBtn" onclick="changeLang('de')">
                DE
              </button>
              <button class="btn btn-secondary m-2 pt-1 br1 text-white" id="enBtn" onclick="changeLang('en')">
                EN
              </button>
              <button class="btn btn-secondary m-2 pt-1 br1 text-white" id="trBtn" onclick="changeLang('tr')"
                v-if="siteLang !== 'DE'">
                TR
              </button>
            </div>
          </div>
          <div v-if='showQR' class='card-body'>
            <div class="row">
              <div class="col-12">
                <qr-code :size='250' :text='loginSessionID'></qr-code>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-12 d-flex justify-content-center">
                <button class='btn text-white btn-primary br1' @click='changeTo'>
                  <span id="loginFormBtnTxt">Login Form</span>
                </button>
              </div>
            </div>
          </div>
          <div v-else class='card-body'>
            <error :errors="form.get('info')" :visible="form.has('info')"></error>
            <div class='info-form'>
              <form class='login-form' @keydown='form.clear($event.target.id)' @submit.prevent='submitForm'>
                <div class='floating-label'>
                  <input id='username' v-model='form.username' :placeholder='LoginForm.usernameTxt[LoginForm.lang]'
                    autofocus required type='text'>
                  <label class='pl-2' for='username'>{{ LoginForm.usernameTxt[LoginForm.lang] }}</label>
                </div>
                <error :errors="form.get('username')" :visible="form.has('username')"></error>
                <div class='floating-label'>
                  <input id='password' v-model='form.password' :placeholder='LoginForm.passwordTxt[LoginForm.lang]'
                    :type='form.passwordType' required>
                  <label class='pl-2' for='password'>{{ LoginForm.passwordTxt[LoginForm.lang] }}</label>
                  <div class='icon d-flex justify-content-center align-items-center' @click='form.togglePassword()'>
                    <span v-if='form.showPassword' class='fa fa-eye'></span>
                    <span v-else class='fa fa-eye-slash'></span>
                  </div>
                </div>
                <error :errors="form.get('password')" :visible="form.has('password')"></error>
                <button :disabled="form.any() && !form.get('info')"
                  :class="LoginForm.location === 'TR' ? 'btn btnSm btn-block text-white login-green br1' : 'btn btn-block text-white login-green br1'"
                  type='submit'>
                  <span>{{ LoginForm.loginTxt[LoginForm.lang] }}</span>
                </button>
                <a :class="LoginForm.location === 'TR' ? 'btn btnSm text-white btn-block mt-2 forget-password br1' : 'btn btn-block text-white forget-password br1'"
                  href='#' @click='resetFormShow = true'>
                  <span>{{ LoginForm.forgetPassword[LoginForm.lang] }}</span>
                </a>
                <a v-if="LoginForm.location === 'TR'"
                  :class="LoginForm.location === 'TR' ? 'btn btnSm text-white btn-block mt-2 btn-secondary br1' : 'btn text-white btn-block mt-2 btn-secondary br1'"
                  href='https://tr.minticity.com/activation'>
                  <span>{{ LoginForm.activationTxt[LoginForm.lang] }}</span>
                </a>
              </form>
            </div>
            <div :class="LoginForm.location === 'TR' ? 'row loginFormFooterSm loginFormFooter' : 'row loginFormFooter'">
              <div class="col-12 d-flex justify-content-center">
                <span class="text-center cursor-pointer mr-4" @click='changeTo'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="currentColor"
                    class="bi bi-qr-code-scan" viewBox="0 0 16 16">
                    <path
                      d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0v-3Zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5ZM.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5Zm15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5ZM4 4h1v1H4V4Z" />
                    <path d="M7 2H2v5h5V2ZM3 3h3v3H3V3Zm2 8H4v1h1v-1Z" />
                    <path d="M7 9H2v5h5V9Zm-4 1h3v3H3v-3Zm8-6h1v1h-1V4Z" />
                    <path
                      d="M9 2h5v5H9V2Zm1 1v3h3V3h-3ZM8 8v2h1v1H8v1h2v-2h1v2h1v-1h2v-1h-3V8H8Zm2 2H9V9h1v1Zm4 2h-1v1h-2v1h3v-2Zm-4 2v-1H8v1h2Z" />
                    <path d="M12 9h2V8h-2v1Z" />
                  </svg>
                </span>
                <a :class="LoginForm.location === 'TR' ? 'btn loginFormFooterBtnSm btn-secondary' : 'btn btn-sm btn-secondary'"
                  target='_blank' href='https://forms.monday.com/forms/d49974ca78ed0c60747c16c8e68b4a94'
                  v-if="LoginForm.location === 'TR'">
                  <i class="fa fa-question-circle mr-1"></i>
                  <span class="supportTxt">Destek</span>
                </a>
                <a :class="LoginForm.location === 'TR' ? 'btn loginFormFooterBtnSm btn-secondary' : 'btn btn-sm btn-secondary'"
                  target='_blank' href='https://forms.monday.com/forms/809b6bffc58c90f1927c4cab2cbe2c84'
                  v-else-if="LoginForm.location == 'EN'">
                  <i class="fa fa-question-circle mr-1"></i>
                  <span class="supportTxt">Support</span>
                </a>
                <a :class="LoginForm.location === 'TR' ? 'btn loginFormFooterBtnSm btn-secondary' : 'btn btn-sm btn-secondary'"
                  target='_blank' href='https://forms.monday.com/forms/4d2c944a6ca8d8a6479154f12ee49db2' v-else>
                  <i class="fa fa-question-circle mr-1"></i>
                  <span class="supportTxt">Unterstützung</span>
                </a>
                <!-- <div class='mt-4 bg-dark text-white p-2' v-if="LoginForm.location == 'TR'">
                  <a class='text-white' target='_blank' href='https://forms.monday.com/forms/d49974ca78ed0c60747c16c8e68b4a94'>
                    <i class="fa fa-question-circle mr-1"></i>
                    <span class="supportTxt">Destek</span>
                  </a>
                </div>
                <div class='mt-4 bg-dark text-white p-2' v-else-if="LoginForm.location == 'DE'">
                  <a class='text-white' target='_blank' href='https://forms.monday.com/forms/4d2c944a6ca8d8a6479154f12ee49db2'>
                    <i class="fa fa-question-circle mr-1"></i>
                    <span class="supportTxt">Unterstützung</span>
                  </a>
                </div>
                <div class='mt-4 bg-dark text-white p-2' v-else>
                  <a class='text-white' target='_blank' href='https://forms.monday.com/forms/809b6bffc58c90f1927c4cab2cbe2c84'>
                    <i class="fa fa-question-circle mr-1"></i>
                    <span class="supportTxt">Support</span>
                  </a>
                </div> -->
                <!--<div class='mt-4 bg-dark text-white p-2' v-if="LoginForm.location == 'TR'">Support : 0850 304 64 68 | <a
                  href='mailto:minticity@das-akademie.de'>E-mail Support</a></div>
                  <div class='mt-4 bg-dark text-white p-2' v-if="LoginForm.location == 'DE'"><a
                    href='mailto:minticity@das-akademie.de'>Support</a></div>-->
                <!-- <div class="row">
                  <div class="col-12">
                    <div class='d-flex align-items-right justify-content-end'>
                      <div><span>{{ LoginForm.adviceTxt[LoginForm.lang] }}</span></div>
                          <img :src='iOS ? LoginForm.safari : LoginForm.google' class='img-fluid loginImage'>
                        <div v-if='!supposedToBe'>
                              <div class='text-center bg-danger rounded text-white warning-not' v-html='LoginForm.warningTxt[LoginForm.lang]'></div>
                        </div>
                      </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class='card card-login'>
      <div class="row mintiLogoAreaRow">
        <div class="col-12 mintiLogoArea">
          <a href="https://www.minticity.com/">
            <img src="https://cdn.minticity.com/assets/images/logo-lg.png" class="mintiLogoImg" alt="logo">
          </a>
        </div>
      </div>
      <div class="row loginFormAreaRow">
        <div class="col-12 loginFormArea">
          <div class='card-body'>
            <div class="row my-2">
              <div class="col-12">
                <h4 class="text-center">{{ LoginForm.forgetPassword[LoginForm.lang] }}</h4>
              </div>
            </div>
            <error :errors="resetForm.get('info')" :visible="resetForm.has('info')"></error>
            <div class='info-form my-4'>
              <form class='login-form' @keydown='resetForm.clear($event.target.id)' @submit.prevent='submitReset'>
                <div class='floating-label'>
                  <input id='usernamereset' v-model='resetForm.usernamereset'
                    :placeholder='LoginForm.usernameTxt[LoginForm.lang]' autofocus type='text'>
                  <label class='pl-2' for='usernamereset'>{{ LoginForm.usernameTxt[LoginForm.lang] }}</label>
                </div>
                <error :errors="resetForm.get('usernamereset')" :visible="resetForm.has('usernamereset')"></error>
                <div class='floating-label'>
                  <input id='emailreset' v-model='resetForm.emailreset' autofocus placeholder='E-mail' type='email'>
                  <label class='pl-2' for='emailreset'>E-mail</label>
                </div>
                <error :errors="resetForm.get('emailreset')" :visible="resetForm.has('emailreset')"></error>
                <button :disabled="resetForm.any() && !resetForm.get('info')"
                  class='btn btn-block text-white login-green br1' type='submit'>
                  <span>{{ LoginForm.sendBtn[LoginForm.lang] }}</span>
                </button>
                <button class='btn btn-block text-white forget-password br1 px-5' @click='resetFormShow = undefined'>
                  {{ LoginForm.loginTxt[LoginForm.lang] }}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQRCodeComponent from 'vue-qrcode-component';

let OS = {
  desktop: false,
  iOS: false,
  iPad: false,
  iPhone: false,
  macOS: false,
  windows: false,
};
let Browser = {
  chrome: false,
  mobileSafari: false,
  safari: false,
};

function init() {

  const ua = navigator.userAgent;
  if (/Windows/.test(ua)) {
    OS.windows = true;
  }
  else if (/Mac OS/.test(ua) && !(/like Mac OS/.test(ua))) {
    OS.macOS = true;
  }
  else if (/iP[ao]d|iPhone/i.test(ua)) {
    OS.iOS = true;

    (navigator.appVersion).match(/OS (\d+)/);

    OS.iOSVersion = parseInt(RegExp.$1, 10);

    OS.iPhone = ua.toLowerCase().indexOf('iphone') !== -1;
    OS.iPad = ua.toLowerCase().indexOf('ipad') !== -1;
  }
  if (OS.windows || OS.macOS) {
    OS.desktop = true;
  }

  if ((/Chrome\/(\d+)/).test(ua) && !(/Opera|OPR\//).test(ua)) {
    Browser.chrome = true;
  }
  else if ((/AppleWebKit/).test(ua) && OS.iOS) {
    Browser.mobileSafari = true;
  }
  else if ((/Safari/).test(ua)) {
    Browser.safari = true;
  }

  if (OS.iOS) {
    Browser.chrome = (/CriOS/i).test(ua) || (/GSA/i).test(ua);
  }
}

export default {
  name: 'LoginForm',
  components: {
    'qr-code': VueQRCodeComponent,
  },
  data() {
    return {
      LoginForm,
      siteLang,
      loginSessionID,
      iOS: false,
      timeOut: null,
      showQR: undefined,
      supposedToBe: true,
      resetFormShow: undefined,
      form: new Form({ username: '', password: '' }),
      resetForm: new Form({ usernamereset: '', emailreset: '' }),
    };
  },
  created() {
    // let params = getParams();
    // init();
    // this.iOS = (OS.iOS || OS.iPad || OS.iPhone);
    // if (this.iOS) {
    //   this.supposedToBe = (Browser.mobileSafari || Browser.safari) && !Browser.chrome;
    // }
    // else {
    //   this.supposedToBe = Browser.chrome;
    // }
    // if (params.hasOwnProperty('ua')) {
    //   alert(navigator.userAgent);
    // }
  },
  mounted() {
    $('body').removeClass('loading');
    this.showQR = false;

    this.timeOut = setTimeout(() => {
      window.location.reload();
    }, 1000 * 60 * 5);

  },
  methods: {
    submitForm() {
      let type = window.location.pathname.split('/')[1];
      let _token = $('meta[name="csrf-token"]').attr('content');
      this.form.post('/login', { type, _token })
        .then((response) => {
          $('body').addClass('loading');
          window.location.href = response;
        });
    },
    changeTo() {
      this.showQR = !this.showQR;
    },
    submitReset() {
      this.resetForm.post('/reset')
        .then((response) => {
          if (parseInt(response) === 1) {
            Swal.fire({
              html: '<h4>Deine Benutzerdaten wurden an Deine Emailadresse versendet.</h4>',
              type: 'success',
            });
          }
          if (parseInt(response) === 2) {
            Swal.fire({
              html: 'Du hast das Passwort deines Kindes vergessen? Bitte log dich im <a href=\'https://member.minticity.com\'>PARENT DASHBOARD</a> ein, um es zurückzusetzen.<br />' +
                'Forgot your child\'s password? Please log into  <a href=\'https://member.minticity.com\'>PARENT DASHBOARD</a> to reset it.',
              type: 'info',
            });
          }
        })
        .catch((response) => {
          console.log(response);
        });
    },
  },
  watch: {
    'form.username'() {
      this.form.clear();
    },
    'form.password'() {
      this.form.clear();
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeOut);
  },
};
</script>

<style lang='scss' scoped>
$primary: rgb(182, 157, 230);
$gradient: #38c172;

.login-form {
  button:disabled {
    cursor: not-allowed;
  }

  .floating-label {
    background-color: #FFFFFF;
    position: relative;
    width: 100%;
    margin-bottom: 10px;

    input {
      font-size: 16px;
      padding: 20px 0;
      padding-left: 16px;
      height: 25px;
      border: none;
      border-bottom: solid 1px $gradient;
      background: #FFFFFF;
      box-sizing: border-box;
      transition: all .3s linear;
      color: #000000;
      width: 100%;
      font-weight: 400;
      -webkit-appearance: none;

      &:focus {
        border-bottom: solid 4px $gradient;
        outline: 0;
        box-shadow: 0 2px 6px -8px rgba($primary, .45);
      }
    }

    label {
      position: absolute;
      top: calc(50% - 10px);
      left: 0;
      opacity: 0;
      transition: all .3s ease;
    }

    input:not(:placeholder-shown) {
      padding: 28px 0 12px 16px;
    }

    input:not(:placeholder-shown)+label {
      transform: translate(-1px, -15px);
      opacity: .7;
    }

    .icon {
      cursor: pointer;
      position: absolute;
      top: -7px;
      right: 10px;
      height: 56px;
      width: 44px;
      display: flex;

      span {
        font-size: 1.6rem;
      }
    }
  }
}

.card {
  margin-bottom: 20px;
  /* background-color: rgba(255, 255, 255, 0.6) !important;*/
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  /*-webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .05);*/
  /* box-shadow: 0 1px 1px rgba(0, 0, 0, .05);*/

  .card-header {
    font-size: 1.5rem;
  }
}

.dark-blue {
  background-color: #1b3943;
}

.forget-password {
  background-color: #0f5d89;
}

.login-green {
  background-color: #63ca3f;
}

.loginImage {
  max-width: 15%;
  padding-left: .5rem;
}

.card-login {
  width: 600px;
  height: 650px;
  border-radius: 2.5rem;
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.loginFormArea {
  width: 320px;
}

#card-header {
  background: white;
  border-radius: 2.5rem 2.5rem 0 0;
}

#card-footer {
  background: white;
  border-radius: 0 0 2.5rem 2.5rem;
}

.br25 {
  border-radius: 2.5rem;
}

.br1 {
  border-radius: 1rem;
}

.warning-not {
  line-height: 20px;
  font-size: initial;
  padding: 5px 0;
}

.loginFormAreaRow {
  margin-top: 3rem !important;
  margin-left: -40px;
}

@media (max-width: 576px) {
  .card-login {
    width: 90%;
  }

  .loginFormArea {
    width: 90%;
  }
}

@media(min-width: 650px) {
  .card-login {
    background-image: url('/images/account/login.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
}

.mintiLogoImg {
  width: 145px;
  margin-left: -25px !important;
}

.mintiLogoAreaRow {
  margin-top: 4.3rem !important;
}

.loginFormFooter {
  margin-top: 2rem !important;
}

.btnSm {
  font-size: 0.7rem !important;
  line-height: 1.5 !important;
}

.loginFormFooterSm {
  margin-top: 0.7rem !important;
}

.loginFormFooterBtnSm {
  font-size: 0.7rem !important;
  line-height: 1.5 !important;
}
</style>
